import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/xing-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM140.4 320.2c4.9 0 9.1-2.9 12.6-9.1 32.1-56.5 48.8-85.9 50.1-88.2l-31.9-55.3c-3.4-5.8-7.7-8.7-12.9-8.7h-46.6c-5.8 0-9 4.5-6 10.1l31.4 54c0.1 0.1 0.1 0.2 0 0.2l-49.3 86.7c-2.7 5 0.5 10.3 6 10.3h46.6zM360.1 106.1c2.8-5.3-0.3-10.1-6-10h-46.9c-5.1 0-9.2 2.9-12.5 8.7-66.6 117.4-101.1 178.2-103.4 182.3l66 120.3c3.2 5.8 7.4 8.7 12.9 8.7h46.6c6.1 0 8.8-5 6-10.1l-65.5-119v-0.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/xing-square.js
// module id = 1103
// module chunks = 0